import { FC } from "react";
import SidebarCasinoFiltersContainer from "components/side-bar/common/casino-filter/SidebarCasinoFiltersContainer";
import styles from "./main-sidebar-casino.module.sass";

const MainSidebarCasino: FC = () => {
    return (
        <div className={styles.subNav}>
            <SidebarCasinoFiltersContainer filterClassname={styles.mainFilter} />
        </div>
    );
};

export default MainSidebarCasino;
